import { render, staticRenderFns } from "./RepresentativesStarter.vue?vue&type=template&id=5cb55ce0&"
import script from "./RepresentativesStarter.vue?vue&type=script&lang=js&"
export * from "./RepresentativesStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports